angular.module('vehicle-booking')
    .constant('VehicleBookingReceptionDeskConst', {
        refreshTimer: 5
    })
    .component('vehicleBookingReceptionDesk', {
        templateUrl: 'app/vehicle-booking/reception-desk/index.html',
        controller: function ($scope, $state, $http, $interval, modals, VehicleBookingService, VehicleBookingConst, VehicleBookingReceptionDeskConst) {
            this.VehicleBookingService = VehicleBookingService
            this.$onInit = () => {
                this.loadData()
                this.clockInit()
                this.clockUpdate = $interval(() => this.clockInit(), 1000);
                this.dataReload = $interval(() => this.loadData(), 1000*VehicleBookingReceptionDeskConst.refreshTimer);
            }

            this.clockInit = () => {
                this.currentTime = new Date()
            }

            this.loadData = () => {
                return $http.get("/crm/api/vehicle-booking-reception-desk")
                    .then(response => {
                        this.departures = response.data.filter(item => item.status === "ACCEPTED")
                        this.arrivals = response.data.filter(item => item.status === "PROCESSING")
                    })
            }

            this.isDifferentDay = (time) => {
                return !moment(this.currentTime).isSame(time, 'day')
            }

            this.isDelayed = (time) => {
                return moment(this.currentTime).isAfter(time)
            }

            this.keyHandover = (booking) => {
                VehicleBookingService.handoverKeys(booking)
            }

            this.keyReturn = (booking) => {
                VehicleBookingService.returnKeys(booking)
            }

            this.history = () => {
                modals.open('app/vehicle-booking/reception-desk/history-modal.html', 'VehicleBookingReceptionHistoryController', null, {size: 'lg'}, "$ctrl")
            }

            this.$onDestroy = () => {
                $interval.cancel(this.clockUpdate)
                $interval.cancel(this.dataReload)
            }
            $scope.$on(VehicleBookingConst.eventUpdate, () => this.loadData())
        }
    })
    .controller('VehicleBookingReceptionHistoryController', function ($scope, $rootScope, $http, $uibModalInstance, modals, VehicleBookingConst, VehicleBookingService, VehicleBooking) {
        this.VehicleBookingService = VehicleBookingService
        this.$onInit = () => this.loadData()

        this.loadData = () => {
            return $http.get("/crm/api/vehicle-booking-reception-desk/history").then(response => this.items = response.data)
        }

        this.back = (item) => {
            let content = "Czy na pewno chcesz cofnąć?"
            modals.confirm(content, () => this.backRequest(item))
        }

        this.backRequest = (item) => {
            if(item.status === "FINISHED") {
                return VehicleBooking.returnKeysCancel({id: item.id}).$promise
                    .then(() => {
                        $rootScope.$broadcast(VehicleBookingConst.eventUpdate)
                        this.cancel()
                    })
            }
            else {
                return VehicleBooking.handoverKeysCancel({id: item.id}).$promise
                    .then(() => {
                        $rootScope.$broadcast(VehicleBookingConst.eventUpdate)
                        this.cancel()
                    })
            }
        }

        this.cancel = () => $uibModalInstance.close()
    })
    .run(function (NavbarLeftMenu) {
        NavbarLeftMenu.add({
            authorities: 'ROLE_VEHICLE_BOOKING_RECEPTION_DESK',
            path: '/vehicle-booking-reception-desk',
            ico: 'fa fa-fw fa-tablet',
            name: 'vehicle-booking-reception-desk.menu',
            order: 104,
        })
    })
    .config(function ($stateProvider) {
        $stateProvider
            .state('vehicleBookingReceptionDesk', {
                parent: 'app',
                url: '/vehicle-booking-reception-desk',
                data: {
                    authorities: ['ROLE_VEHICLE_BOOKING_RECEPTION_DESK'],
                },
                views: {
                    'content@': 'vehicleBookingReceptionDesk'
                }
            })
    })
